<template>
  <div class="modal"
       id="modal-update-user"
       tabindex="-1"
       role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Edit {{ role | capitalize }} #{{ user.id }}
          </h5>
        </div>

        <div class="modal-body">
          <form role="form">
            <div class="form-group row">
              <label for="name" class="col-md-4 col-form-label text-md-right">Name</label>

              <div class="col-md-6">
                <input id="name"
                       type="text"
                       class="form-control"
                       name="name"
                       v-model="updateUserForm.name"
                       :class="{'is-invalid': updateUserForm.errors.has('name')}"
                       required autofocus>

                <span class="invalid-feedback"
                      role="alert"
                      v-if="updateUserForm.errors.has('name')">
                  <strong>{{ updateUserForm.errors.get('name') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="email" class="col-md-4 col-form-label text-md-right">Email</label>

              <div class="col-md-6">
                <input id="email"
                       type="email"
                       class="form-control"
                       name="email"
                       v-model="updateUserForm.email"
                       :class="{'is-invalid': updateUserForm.errors.has('email')}"
                       required autofocus>

                <span class="invalid-feedback"
                      role="alert"
                      v-if="updateUserForm.errors.has('email')">
                  <strong>{{ updateUserForm.errors.get('email') }}</strong>
                </span>
              </div>
            </div>
            <div class="col-md-6 ml-2">
              <a style="cursor: pointer"><p class="text-primary" @click="changePasswordToggle">Change
                Password</p>
              </a>
            </div>

            <div v-show="showPassword">
              <div class="form-group row">
                <label for="password" class="col-md-4 col-form-label text-md-right">Password</label>

                <div class="col-md-6">
                  <input id="password"
                         type="password"
                         class="form-control"
                         name="password"
                         @click="removeError('password')"
                         v-model="updateUserForm.password"
                         :class="{'is-invalid': updateUserForm.errors.has('password')}"
                         required autofocus>

                  <span class="invalid-feedback"
                        role="alert"
                        v-if="updateUserForm.errors.has('password')">
                    <strong>{{ updateUserForm.errors.get('password') }}</strong>
                  </span>
                </div>
              </div>

              <div class="form-group row">
                <label for="password-confirm" class="col-md-4 col-form-label text-md-right">Confirm
                  Password</label>

                <div class="col-md-6">
                  <input id="password-confirm"
                         type="password"
                         class="form-control"
                         name="password_confirmation"
                         :class="{'is-invalid': updateUserForm.errors.has('password_confirmation')}"
                         v-model="updateUserForm.password_confirmation"
                         required>

                  <span class="invalid-feedback"
                        role="alert"
                        v-if="updateUserForm.errors.has('password_confirmation')">
                    <strong>{{ updateUserForm.errors.get('password_confirmation') }}</strong>
                  </span>
                </div>
              </div>
            </div>

          </form>
        </div>

        <div class="modal-footer">
          <button type="button"
                  class="btn btn-default"
                  data-dismiss="modal">
            Close
          </button>
          <button type="button"
                  class="btn btn-primary"
                  @click="updateUser"
                  :disabled="updateUserForm.busy">
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['user', 'role'],

  /**
   * The component's data.
   */
  data () {
    return {
      updateUserForm: new AppForm({
        name: null,
        email: null,
        password: null,
        password_confirmation: null,
        role: null,
      }),
      showPassword: false,
    };
  },

  mounted () {
    this.initData(this.user);
  },

  watch: {
    user: function (newUser, oldUser) {
      this.initData(newUser);
    }
  },

  methods: {
    changePasswordToggle () {
      this.showPassword = !this.showPassword;
    },

    initData (user) {
      this.updateUserForm.name = user.name;
      this.updateUserForm.email = user.email;
    },

    removeError (error) {
      if (this.updateUserForm.errors.has(error)) {
        this.updateUserForm.errors.forget(error);
      }
    },

    updateUser () {
      let self = this;

      this.updateUserForm.role = this.role;

      App.put('/api/users/' + this.user.id, this.updateUserForm)
        .then(() => {
          this.showPassword = false;
          self.updateUserForm.name = null;
          self.updateUserForm.email = null;
          self.updateUserForm.password = null;
          self.updateUserForm.password_confirmation = null;
          self.updateUserForm.role = null;

          $('#modal-update-user').modal('hide');

          self.$parent.$emit('updateUsers');

          self.$parent.$emit('getUser', self.user.id);
          self.$parent.$emit('updateUsers');
        }).catch(response => {
        this.showPassword = true;
      });
    },
  }
};
</script>
